module.exports = __webpack_public_path__ + "media/applicants/newyorktimes-786a1360.jpg";